var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownwardIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#1450ff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1225 -222)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1223.63 223.096)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 14,
    transform: "translate(10.37 0.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.74,12l-5.37,5.37L5,12",
    transform: "translate(0 -2.562)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 18,
    height: 18,
    transform: "translate(1225 222)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownwardIcon);
export default __webpack_public_path__ + "static/media/arrow-downward-icon.d6618db21cb3ac3ca84bc17c3887242e.svg";
export { ForwardRef as ReactComponent };